import { render } from "./PaymentsView.vue?vue&type=template&id=4e341bfa&scoped=true"
import script from "./PaymentsView.vue?vue&type=script&lang=js"
export * from "./PaymentsView.vue?vue&type=script&lang=js"

import "./PaymentsView.vue?vue&type=style&index=0&id=4e341bfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e341bfa"]])

export default __exports__